export interface Institution {
    Id: number;
    Name: string;
    LogoId: string;
}

export class CreateInstitutionModel {
    name: string;
    logoId: string;
}

export class EditInstitutionModel extends CreateInstitutionModel {
    id: number;
    constructor(item?: Institution){
        super();
        this.id = item && item.Id;
        this.name = item && item.Name;
        this.logoId = item && item.LogoId;
    }
 }


// WEBPACK FOOTER //
// ./src/app/models/inModels/Institution.ts